<template>
	<div class="Modal ModalInviteEmail">
		<modal-background></modal-background>
		<div class="Modal__container whole">
			<div class="Modal__top">
				<p>{{ tt('이메일로 초대하기') }}</p>
				<button class="Modal__close-btn" @click="close">
					<img src="@/assets/svg/close-popup.svg" alt="closeBtn" />
				</button>
			</div>
			<div class="Modal__content">
				<progress-input-auto-increment
					v-for="(item, index) in emailList"
					:key="index"
					:index="index"
					:length="emailList.length"
					v-model="emailList[index]"
					:placeholder="'이메일'"
					:isValid="isValid[index]"
					:validText="validText[index]"
					@update="updateEmail"
					@clickDelete="clickDeleteEmail"
				>
				</progress-input-auto-increment>
				<button class="Btn__complete" @click="submit">
					{{ tt('이메일 전송') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import ModalBackground from '@/views/common/modals/components/ModalBackground.vue'
import ProgressInputAutoIncrement from '@/views/create/components/ProgressInputAutoIncrement.vue'
export default {
	name: 'ProgressInputEmailInvite',
	props: {},
	components: {
		ModalBackground,
		ProgressInputAutoIncrement,
	},
	data() {
		return {
			isValid: [],
			validText: [],
			emailList: [''],
		}
	},
	computed: {},
	watch: {},
	methods: {
		updateEmail(index, email) {
			if (email.length === 1 && this.emailList[index + 1] === undefined) {
				this.emailList.push('')
			} else {
				if (this.isValid[index] != null) {
					this.isValid.splice(index, 1, true)
					this.validText.splice(index, 1, '')
				} else {
					this.isValid.push(true)
					this.validText.push('')
				}
			}
		},
		clickDeleteEmail(index) {
			this.emailList.splice(index, 1)
			this.isValid.splice(index, 1, true)
			this.validText.splice(index, 1, '')
		},
		validation() {
			this.validText = []
			this.isValid = []
			let result = true

			const emailRule =
				/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i

			this.emailList.forEach((email, index) => {
				if (
					!emailRule.test(email) &&
					index + 1 != this.emailList.length
				) {
					this.validText[index] = '이메일 형식이 맞지 않습니다'
					this.isValid[index] = false
				} else if (
					this.emailList.length === 1 &&
					this.emailList[0] === ''
				) {
					this.validText[index] = '이메일을 입력해주시기 바랍니다'
					this.isValid[index] = false
				}
			})

			if (this.isValid.includes(false)) {
				result = false
			}

			return result
		},
		submit() {
			if (!this.validation()) {
				return false
			}
			this.emailList.pop()
			this.$emit('submit', this.emailList)
			this.$emit('close')
		},
		close() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
.ModalInviteEmail {
	.Modal__container {
		height: 95vh;
		.Modal__top {
			p {
				font-weight: 700;
			}
		}
		.Modal__content {
			padding: 20px;
		}
		.email-item {
			width: 100%;
			border: 1px solid #ddd;
			border-radius: 8px;
			padding: 8px 14px;
			position: relative;
			margin-bottom: 10px;
			span {
				font-size: 0.75rem;
				font-weight: 400;
				display: block;
				color: #999;
			}
			p {
				font-size: 1rem;
				font-weight: 400;
				margin-top: 2px;
			}
			button {
				position: absolute;
				top: 50%;
				right: 18px;
				transform: translateY(-50%);
				img {
					width: 18px;
					height: 18px;
				}
			}
		}
		.input-box {
			width: 100%;
			position: relative;
			&.error {
				input {
					border-color: #ff5746;
				}
				span {
					display: flex;
				}
			}
			input {
				width: 100%;
				height: 56px;
				border-radius: 8px;
				border: 1px solid #ddd;
				padding: 10px 14px 0 14px;
				font-size: 1rem;
			}
			input:focus {
				border-color: #000;
			}
			input:focus ~ .placeholder {
				font-size: 0.75rem;
				top: 5px;
			}
			.placeholder {
				position: absolute;
				font-size: 1rem;
				font-weight: 400;
				color: #999;
				display: block;
				top: 16px;
				left: 14px;
				transition: all 0.3s;
				background-color: unset !important;
				&.active {
					font-size: 0.75rem;
					top: 5px;
				}
			}
			.noti {
				font-size: 0.75rem;
				font-weight: 400;
				background-image: url(~@/assets/svg/icon-error_r.svg);
				background-repeat: no-repeat;
				background-position: top 2px left 0;
				padding-left: 16px;
				color: #ff5746;
				text-align: left;
				display: none;
				margin-top: 4px;
			}
		}
	}
	.Btn__complete {
		width: 100%;
		height: 48px;
		margin-top: 20px;
		font-size: 1rem;
	}
}
</style>
